import { ValidPlatform, ValidPlatformArch } from '@kemu-io/hs-types';

const BASE_URL = `${process.env.REACT_APP_PLATFORM_API}/v1/hub/download`;

/**
 * Get the appropriate Hub download URL based on platform and architecture
 */
const getHubDownloadUrl = (platform: ValidPlatform | null, architecture: ValidPlatformArch | null): string => {
  if (platform === 'osx' && architecture === 'osx-arm64') {
    return `${BASE_URL}?platform=mac&arch=arm64&package=dmg`;
  }

  if (platform === 'osx' && architecture === 'osx-x64') {
    return `${BASE_URL}?platform=mac&arch=x64&package=dmg`;
  }

  if (platform === 'linux') {
    const arch = architecture?.includes('arm64') ? 'arm64' : 'x64';
    return `${BASE_URL}?platform=linux&arch=${arch}&package=deb`;
  }

  return `${BASE_URL}?platform=win&arch=x64&package=exe`;
};

export default getHubDownloadUrl;
